import script from "./paymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentModal.vue?vue&type=script&setup=true&lang=js"

import "./paymentModal.vue?vue&type=style&index=0&id=82664dfa&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82664dfa"]])

export default __exports__